export default "__VITE_ASSET__e5f8cdef__"